"use strict";
exports.__esModule = true;
var angular = require("angular");
require("../../lib/textangular/dist/textAngular-sanitize.js");
require("../../lib/textangular/dist/textAngular.umd.js");
require("../../lib/textangular/dist/textAngular.css");
var so_angular_quill_js_component_1 = require("./so-angular-quill-js/so-angular-quill-js.component");
var COMPONENT_NAME = 'so.richtextbox';
var SoRichTextBoxComponent = /** @class */ (function () {
    function SoRichTextBoxComponent($scope, $element) {
        this.$scope = $scope;
        this.componentElem = $element[0];
        this.typeOptions = { quill: 'quilljs', textAngular: 'textangular' };
        // this.richTextBoxType = (localStorage.getItem('richTextBox') || 'quillJS').toLowerCase();
        this.richTextBoxType = 'quilljs';
    }
    SoRichTextBoxComponent.prototype.$onChanges = function (changes) {
        if (changes.ngModel) {
            if (changes.ngModel.currentValue !== changes.ngModel.previousValue) {
                this.richTextVal = changes.ngModel.currentValue;
            }
        }
    };
    SoRichTextBoxComponent.prototype.onContentChange = function (content) {
        // console.log('Changed:', content, this.richTextVal);
        var _this = this;
        this.$scope.$applyAsync(function () {
            _this.ngModelCtrl.$setViewValue(_this.richTextVal);
            _this.ngModelCtrl.$render();
            if (_this.onContentChanged) {
                _this.onContentChanged({ content: _this.richTextVal });
            }
        });
    };
    return SoRichTextBoxComponent;
}());
angular.module(COMPONENT_NAME, [
    so_angular_quill_js_component_1["default"],
    'textAngular',
]).component('soRichTextBox', {
    template: require('./so-rich-text-box.component.html'),
    require: {
        ngModelCtrl: 'ngModel'
    },
    bindings: {
        placeholder: '@?',
        toolbarSet: '@?',
        rtHeight: '@?',
        onContentChanged: '&?',
        readOnly: '<?',
        ngModel: '<'
    },
    controller: SoRichTextBoxComponent
});
exports["default"] = COMPONENT_NAME;
//# sourceMappingURL=so-rich-text-box.component.js.map


// WEBPACK FOOTER //
// ./app/components/so-rich-text-box/so-rich-text-box.component.js